import { useODataReadInfiniteApi } from '@msrceng/component';
import { useTranslation } from 'react-i18next';

export enum ApiSchemaName {
  affectedProduct = 'affectedProduct',
}

/** This is an individual MSRC API name and value pair in a larger enum */
export interface IMsrcApiMetadataPropertyValue {
  /** This is an optional parent or group key */
  groupName?: string;
  /** This enum element's user friendly name */
  displayName: string;
  /** If this is set to false, this element is intended as a heading of some kind */
  isSelectable: boolean;
  /** This enum element's value */
  value: string;
}

/** This is a metadata enum */
export interface IMsrcApiMetadataProperty {
  /** This enum's user friendly name */
  displayName: string;
  /** This enum's values */
  propertyValues: IMsrcApiMetadataPropertyValue[];
  /** This enum's data name */
  schemaName: string;
}

/** This represents an OData entity */
export interface IMsrcApiMetadataResponse {
  /** The entity's GUID (this is probably not useful at all) */
  id: string;
  /** This is the data about this entity */
  metadata: {
    /** This is the data name for this entity */
    schemaName: ApiSchemaName;
    /** This entity's user friendly name */
    displayName: string;
    /** This entity's properties (which are all just enums at this point) */
    properties: IMsrcApiMetadataProperty[];
  };
}

/**
 * Gets the list of metadata API items. This is an internal
 * tool and is hard to use. You should use `useMetadataStructuredApi`
 * instead if possible.
 */
export const useMetadataInfiniteApi = () => {
  const [_t, i18n] = useTranslation();
  return useODataReadInfiniteApi<IMsrcApiMetadataResponse>(
    `/sug/v2.0/${i18n.language}/metadata`,
    {},
    {
      enabled: i18n.isInitialized,
      isAuthRequired: false,
      isVerificationRequired: false,
    }
  );

  // const flatData= api.data?.pages?.flat(1)
  // //Gracefull fallthrough to support multiple metadata variants we've used:
  // // original: {data:metadata}
  // // r1: {data:{value:metadata[]}}
  // // r2: {data:{value:{metadata}[]}}
  // const data =
  //   flatData?. ||
  //   flatData?.value?.[0]?.metadata ||
  //   flatData?.value?.[0] ||
  //   flatData;
  // return {
  //   ...api,
  //   data,
  // };
};

//   /** Fetches the affectedProduct metadata endpoint   */
//   const getMetadata = async () => {
//     await getApiRoot();
//     // return Axios.get(`/metadata/${endpoint}`)
//     if (i18n.language && !wholeMetadataEndpointResponse) {
//       wholeMetadataEndpointResponse = await Axios.get<any>(
//         `/sug/v2.0/${i18n.language}/metadata`
//       )
//         .then(res => {
//           //TODO: Remove this when metadata stabilizes:
//           //Gracefull fallthrough to support multiple metadata variants we've used:
//           // original: {data:metadata}
//           // r1: {data:{value:metadata[]}}
//           // r2: {data:{value:{metadata}[]}}
//           return (
//             res?.data?.metadata ||
//             res?.data?.value?.[0]?.metadata ||
//             res?.data?.value?.[0] ||
//             res?.data
//           );
//         })
//         .then(data => mapResultMetadataItem(data));
//     }
//     return wholeMetadataEndpointResponse;
//   };
